<template>
  <dl class="rounded-lg border border-gray-200 bg-brand-white lg:px-8 p-4">
    <div class="flex gap-4 items-center justify-between xl:grid xl:grid-cols-2">
      <div class="">
        <h4 class="lg:text-xl font-semibold">
          {{ selectedCar?.model }}
        </h4>
        <span class="text-gray-400 text-lg">{{ selectedCar?.price }}</span>

        <div class="flex gap-12 mt-4">
          <DescriptionListItem>
            <template #title>
              <span class="capitalize">{{ $t('duration', 2) }}</span>
            </template>
            <template #default>
              {{ selectedBooking?.monthsLong }} {{ $t('month', cartStore.selectedBooking.monthsLong) }}
            </template>
          </DescriptionListItem>
          <DescriptionListItem>
            <template #title>
              <span class="capitalize">{{ $t('kilometers') }}</span>
            </template>
            <template #default>
              {{ selectedBooking?.km }}Km/{{ $t('month') }}
            </template>
          </DescriptionListItem>
        </div>
      </div>

      <div class="flex items-center justify-center">
        <BaseImage
          :src="selectedCar.imageSrc"
          :alt="selectedCar.model"
          :title="selectedCar.model"
          class="max-w-full max-h-40 object-cover"
        />
      </div>
    </div>
  </dl>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import DescriptionListItem from '~/components/modals/DescriptionListItem.vue';
import { useCartStore } from '~/stores/cartStore';
import BaseImage from '../BaseImage.vue';

const cartStore = useCartStore();
const { selectedCar, selectedBooking /* recurrentPaymentFeaturesItems , computedTotal */ } = storeToRefs(cartStore);
</script>
